module.exports = __webpack_public_path__ + "img/bottom-2-mobile.ae6674e2.jpg";